/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { INurse } from 'app/shared/model/nurse.model';

export interface IPreOpCheckList {
  id?: string;
  preparation?: boolean;
  vitals?: boolean;
  amCareSponge?: boolean;
  amCareShower?: boolean;
  urinaryTime?: number;
  urinaryCatheter?: boolean;
  enemaBowlWash?: boolean;
  enemaLaxatives?: boolean;
  preOpMedsGiven?: boolean;
  preOpMedsGivenTime?: number | null;
  skinPreparation?: boolean;
  nbm?: boolean;
  consent?: boolean;
  makingOfSite?: boolean;
  medicationProfile?: boolean;
  denturesRemoved?: boolean;
  lensesRemoved?: boolean;
  prostesisRemoved?: boolean;
  prostesisNames?: string | null;
  jewelleryRemoved?: boolean;
  highRiskConsent?: boolean;
  bloodType?: boolean;
  bloodScreen?: boolean;
  bloodHoldReady?: boolean;
  pacDone?: boolean;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  anaesthesiologist?: IDoctor;
  nurse?: INurse;
}

export const defaultValue: Readonly<IPreOpCheckList> = {
  preparation: false,
  vitals: false,
  amCareSponge: false,
  amCareShower: false,
  urinaryCatheter: false,
  enemaBowlWash: false,
  enemaLaxatives: false,
  preOpMedsGiven: false,
  skinPreparation: false,
  nbm: false,
  consent: false,
  makingOfSite: false,
  medicationProfile: false,
  denturesRemoved: false,
  lensesRemoved: false,
  prostesisRemoved: false,
  jewelleryRemoved: false,
  highRiskConsent: false,
  bloodType: false,
  bloodScreen: false,
  bloodHoldReady: false,
  pacDone: false,
  active: false,
};
